import { render, staticRenderFns } from "./Embed.vue?vue&type=template&id=664d49ac&"
import script from "./Embed.vue?vue&type=script&lang=js&"
export * from "./Embed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports